import { IntegrationsScreen } from '@/features/integrations/IntegrationsScreen';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/integrations')({
  staticData: { nav: 'integrations' },
  validateSearch: z.object({ connect: z.string().optional(), result: z.string().optional() }),
  component: IntegrationsScreen,
});
